<div class="flex justify-content-between align-items-center">
  <div class="ml-3 font-semibold text-l">{{ config?.label }}</div>
  <p-button
    text
    size="small"
    [label]="config?.createButtonLabel ?? 'Προσθήκη Νέου'"
    [icon]="config?.createButtonIcon ?? 'pi pi-plus'"
    [styleClass]="config?.createButtonStyleClass"
    (onClick)="onCreateButtonClick()"
  />
</div>

<p-table [value]="config?.tableData ?? []">
  <ng-template pTemplate="header">
    <tr class="th-bg-gray-50 th-font-semibold">
      <th *ngFor="let prop of config?.formFields">
        {{ prop.label }}
      </th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item>
    <tr>
      <td *ngFor="let prop of config?.formFields">
        {{ item?.[prop.fieldId] }}
      </td>
      <td>
        <p-button
          text
          icon="pi pi-trash"
          severity="danger"
          [loading]="deleteLoading"
          [disabled]="deleteLoading"
          (onClick)="onDelete(item)"
        />
      </td>
    </tr>
  </ng-template>
</p-table>

@if (formConfig) {
<p-dialog
  #dialog
  [focusOnShow]="false"
  [header]="config?.formHeader"
  [modal]="true"
  [(visible)]="formDialogVisible"
  [style]="{ width: '70vw' }"
>
  <eo-form
    #eoForm
    [config]="formConfig"
    [submitButtonVisible]="false"
    (formSubmit)="onFormSubmit($event)"
  />

  <div class="w-full flex justify-content-end">
    <p-button
      [label]="config?.submitButtonLabel ?? 'Αποθήκευση'"
      [loading]="submitLoading"
      [disabled]="!eoForm.valid || submitLoading"
      (onClick)="onFormSubmit(eoForm.getFormData())"
    />
  </div>
</p-dialog>
}
